import React from 'react';
import './Market/Market.css'
import MarketUI from './Market/MarketUI';

function Market() {
  return (
      <>
        <MarketUI />
      </>
  )
}

export default Market;
